import React, { FC } from "react";
import {
  CardIconWrapper,
  CardIconWrapperProps,
} from "../CardIconWrapper/CardIconWrapper";

import { Icon } from "@UI/Components/Icon/Icon";

import { BancontactIcon } from "../../../Icons/Bancontact/Bancontact";

type Props = Omit<CardIconWrapperProps, "children">;

export const BancontactCardIcon: FC<Props> = (props) => {
  return (
    <CardIconWrapper {...props}>
      <Icon as={BancontactIcon} />
    </CardIconWrapper>
  );
};
